import * as actionTypes from './actionTypes'
import appraisalDropdownAxios from '../../axios/appraisalDropdown'

export const fetchCompanyOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchCompanyOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/company', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCompanyOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCompanyOptionsAppraisalFailed(error))
      })
  }
}

export const fetchCompanyOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchCompanyOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchCompanyOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchStructureOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchStructureOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/structure', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchStructureOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchStructureOptionsAppraisalFailed(error))
      })
  }
}

export const fetchStructureOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchStructureOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchStructureOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchLevelGroupOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchLevelGroupOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/level_group', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelGroupOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelGroupOptionsAppraisalFailed(error))
      })
  }
}

export const fetchLevelGroupOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchLevelGroupOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchLevelGroupOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Organization

export const fetchOrganizationOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchOrganizationOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/org', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrganizationOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrganizationOptionsAppraisalFailed(error))
      })
  }
}

export const fetchOrganizationOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchOrganizationOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchOrganizationOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Position

export const fetchPositionOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchPositionOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/position', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPositionOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPositionOptionsAppraisalFailed(error))
      })
  }
}

export const fetchPositionOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchPositionOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchPositionOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Employee

export const fetchEmployeeOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchEmployeeOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/employee', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchEmployeeOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchEmployeeOptionsAppraisalFailed(error))
      })
  }
}

export const fetchEmployeeOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchEmployeeOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchEmployeeOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Form Options

export const fetchFormOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchFormOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/form', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchFormOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchFormOptionsAppraisalFailed(error))
      })
  }
}

export const fetchFormOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchFormOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchFormOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Criteria

export const fetchCriteriaOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchCriteriaOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/criteria', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCriteriaOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCriteriaOptionsAppraisalFailed(error))
      })
  }
}

export const fetchCriteriaOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchCriteriaOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchCriteriaOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchResponsibleOptionsAppraisal = (filterOptions, structureId, itemData) => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchResponsibleOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/responsible', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(
            fetchResponsibleOptionsAppraisalSuccess(response.data.data, structureId, itemData)
          )
        }
      })
      .catch(error => {
        dispatch(fetchResponsibleOptionsAppraisalFailed(error))
      })
  }
}

export const fetchResponsibleOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchResponsibleOptionsAppraisalSuccess = (data, structureId, itemData) => {
  return {
    type: actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data,
    structureId,
    itemData
  }
}

export const fetchResponsibleOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchAppraisalStatusOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchAppraisalStatusOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/appraisal_status', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAppraisalStatusOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalStatusOptionsAppraisalFailed(error))
      })
  }
}

export const fetchAppraisalStatusOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchAppraisalStatusOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchAppraisalStatusOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchAssignmentStatusOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchAssignmentStatusOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/assignment_status', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAssignmentStatusOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAssignmentStatusOptionsAppraisalFailed(error))
      })
  }
}

export const fetchAssignmentStatusOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchAssignmentStatusOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchAssignmentStatusOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchAppraisalTypeOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchAppraisalTypeOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/appraisal_type', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAppraisalTypeOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalTypeOptionsAppraisalFailed(error))
      })
  }
}

export const fetchAppraisalTypeOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchAppraisalTypeOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchAppraisalTypeOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Forced Organization

export const fetchForcedOrganizationOptionsAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchForcedOrganizationOptionsAppraisalStart())
    appraisalDropdownAxios
      .get('/forced_org', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchForcedOrganizationOptionsAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchForcedOrganizationOptionsAppraisalFailed(error))
      })
  }
}

export const fetchForcedOrganizationOptionsAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchForcedOrganizationOptionsAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchForcedOrganizationOptionsAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}
